import format from "date-fns/format";
import React, { useEffect, useState } from "react";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineClock, HiOutlineTicket, HiQrcode } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
// import "./style.scss";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";
import useOpenToSelect from "../hooks/useOpenToSelect";
import useFacility from "../../../../utils/hooks/useFacility";
import HtmlTooltip from "@mui/material/Tooltip";
import EAButton from "../../shared/Buttons/EAButton";
import { parse, isBefore } from "date-fns";
import EAAlert from "../../shared/EAAlert";
import ExercisesPlan from "../ExercisesPlan";
interface IProps {
  ticket: Ticket;
  getSelect: () => void;
}

const ClubCartsDesktop: React.FC<IProps> = ({ ticket, getSelect }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [allowToJoin, setAllowToJoin] = useState(false);
  const [assignedList, setAssignedList] = useState(false);
  const { addPossibilityToJoin } = useOpenToSelect();
  const facilityIds = useFacility();

  const [messageAlert] = useState(`Twój karnet, stracił ważność w dniu ${format(ticket.validto, "dd.MM.yyyy")}r.`);

  const isTicketExpired = (ticket: Ticket) => {
    // Jeśli validto jest liczbą (timestamp), konwertujemy go na datę
    const ticketDate =
      typeof ticket.validto === "number"
        ? new Date(ticket.validto)
        : parse(String(ticket.validto), "dd.MM.yyyy", new Date());

    const today = new Date();

    return isBefore(ticketDate, today);
  };

  useEffect(() => {
    if (facilityIds === "1212" || facilityIds === "1243" || facilityIds === "1241") {
      setAllowToJoin(addPossibilityToJoin(ticket));
    }

    // console.log("TICKET")
    // console.log(ticket)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <React.Fragment>
      {ticket.passtype === 8 && ticket.ticket === false && (
        <div className="purchased-assort">
          <div className="purchased-assort_left">
            {isTicketExpired(ticket) ? (
              <div className="purchased-assort_startIcon_disabled">
                <HiOutlineTicket className="myAccount-ticketLine_icon" />
              </div>
            ) : (
              <div className="purchased-assort_startIcon">
                <HiOutlineTicket className="myAccount-ticketLine_icon" />
              </div>
            )}

            <div className="purchased-assort_body">
              <h5>
                {ticket.name}
                {ticket.description.length > 10 && (
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <article
                          className="tooltip-description"
                          dangerouslySetInnerHTML={{ __html: ticket.description }}
                        ></article>
                      </React.Fragment>
                    }
                  >
                    <b>
                      <BiInfoCircle className="tooltip-icon" />
                    </b>
                  </HtmlTooltip>
                )}
              </h5>

              {isTicketExpired(ticket) ? (
                <EAAlert message={messageAlert} type="error" compact />
              ) : (
                <span className="purchased-assort_body__details">
                  <HiOutlineClock /> {t("wazny_od")}:{" "}
                  <b>
                    {format(ticket.validfrom, "dd.MM.yyyy")}r. | {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}
                    r.
                  </b>
                </span>
              )}
            </div>
          </div>

          {isTicketExpired(ticket) ? (
            <div className="purchased-assort_action">
              {allowToJoin && (
                <EAButton
                  title={t("pokaz_terminy")}
                  onClick={() => setAssignedList(!open)}
                  fullWidth
                  disabled
                  variant="outlined"
                />
              )}
              <EAButton
                title={t("pokaz_kod_qr")}
                onClick={() => setOpen(!open)}
                fullWidth
                endIcon={<HiQrcode />}
                disabled
              />
            </div>
          ) : (
            <div className="purchased-assort_action">
              {allowToJoin && (
                <EAButton
                  title={t("pokaz_terminy")}
                  onClick={() => setAssignedList(!open)}
                  fullWidth
                  variant="outlined"
                />
              )}
              <EAButton title={t("pokaz_kod_qr")} onClick={() => setOpen(!open)} fullWidth endIcon={<HiQrcode />} />
            </div>
          )}
        </div>
      )}
      {open && (
        <ModalComponent
          footer={false}
          open={open}
          leftType="exercise"
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <EAButton title={t("gotowe_schowaj")} onClick={() => setOpen(!open)} />
        </ModalComponent>
      )}

      {assignedList && (
        <ModalComponent
          footer={false}
          leftType="exercise"
          open={assignedList}
          closeModal={() => setAssignedList(false)}
          title={t("najblizsze_rezerwacje")}
          onAccept={() => setAssignedList(false)}
        >
          <ExercisesPlan ticket={ticket} getSelect={getSelect} />
          {/* <React.Fragment>
            <SelectPassBar ticket={ticket} />

           
              
              <div>
              
                {ticket.exercises.map((exercise, index) => (
                  <div key={index}>
                    <SingleExercise exercise={exercise} getSelect={getSelect} />
                  </div>
                ))}
              </div>
        

            {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
          </React.Fragment>  */}
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default ClubCartsDesktop;
